import { isTriggerBack } from "barba"

import "./default.scss"

const duration = 500 // Must be the same as the CSS animation duration
const classLeave = 'is-leave'
const classEnter = 'is-enter'
const classBack = 'is-back'
const classFoward = 'is-foward'
const supportClipPath = (function SupportClipPath() {
    return CSS.supports("(clip-path: circle())") || CSS.supports("(-webkit-clip-path: circle())")
})()



// Return a promise which resolve after N milisecond
function waitMs(ms) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve()
        }, ms);
    })
}



// Listen to update page scroll Y information
let scrollY = 0
let windowWidth = -1
let timeout = null

const updateScrollY = () => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
        window.requestAnimationFrame(() => {
            const ws = window.scrollY
            const ww = window.innerWidth
            if (ww !== windowWidth || ws !== scrollY) {
                scrollY = window.scrollY
                windowWidth = ww
            }
        })
    }, 32)
}

window.addEventListener('scroll', updateScrollY)
window.addEventListener('resize', updateScrollY)
updateScrollY()



// Export transition object, named "default"
export default {
    name: 'sweep',
    sync: true,
    leave({ current }) {
        if (!supportClipPath) {
            return
        }
        current.container.classList.add(classLeave)
        if (isTriggerBack()) {
            current.container.classList.add(classBack)
        } else {
            current.container.classList.add(classFoward)
        }
        current.container.scrollTop = Math.round(scrollY)
        return waitMs(duration)
    },
    enter({ next }) {
        if (!supportClipPath) {
            return
        }
        next.container.classList.add(classEnter)
        return waitMs(duration)
    },
    afterEnter({ next }) {
        next.container.classList.remove(classEnter)
    },
    after() {
        updateScrollY()
    }
};